<template>
  <Icon v-if="arrowToLeft" :type="'arrow-right'"/>
  {{ sistaOrdet[0] }} 
  <span class="sistaordet">
    {{ sistaOrdet[1] }}
    <Icon v-if="!arrowToLeft" :type="'arrow-right'"/>
  </span>
</template>

<script>
import Icon from "common/js/vue/image/icon.vue";

export default {
  name: "SistaOrdet",
  components: {
    Icon
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    arrowToLeft: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  computed: {
    sistaOrdet(){
      const trimmedStr = this.text.trim();
      const sistaOrdet = trimmedStr.split(' ').at(-1);
      let text = "";
      if (sistaOrdet !== trimmedStr)
      {
          text = trimmedStr.substr(0, trimmedStr.lastIndexOf(' ')).trimEnd();
      }

      const arr = [text, sistaOrdet];
      return arr;
    }
  }
};
</script>
